'use strict';

module.exports = {
    init: function() {
        this.options = Odigeo.Utils.parseOptions(this.options);
    },
    loadData: function(data) {
        this.model.loadData(data);
    },
    trackContinueToPayment: function() {
        this.view.trackContinueToPayment();
    },
    trackContinueToConfirmation: function() {
        this.view.trackContinueToConfirmation();
    },
    onNagBtnOptionOF2: function(type) {
        this.view.onNagBtnOptionOF2(type);
    },
    onNagLoadingError: function() {
        this.proceedToPayment();
    },
    onBoardingOptionSelectedOF2: function(type) {
        this.model.selectType(type, true);
    },
};
